import type { IFilterableListItem, IOmit, ISuggestProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Field, Skeleton, Suggest } from '@sixui/ui';

import { AppIcon } from '~/components/atoms/AppIcon';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useAppsQuery } from '~/lib/api/modules/Apps/hooks/useAppsQuery';
import { useOrganizationAppsQuery } from '~/lib/api/modules/Organizations/hooks/useOrganizationAppsQuery';

export type IAppSelectorProps = IOmit<ISuggestProps, 'items'> & {
  organizationId?: string;
};

export const AppSelector = forwardRef<HTMLInputElement, IAppSelectorProps>(
  function AppSelector(props, forwardedRef) {
    const { organizationId, ...other } = props;
    const appsQuery = useAppsQuery({
      enabled: !organizationId,
    });
    const organizationAppsQuery = useOrganizationAppsQuery(
      organizationId ? { organizationId } : undefined,
    );
    const loaded =
      (!!appsQuery.data && !!organizationAppsQuery.data) ||
      (!appsQuery.isLoading && !organizationAppsQuery.isLoading);
    const items: Array<IFilterableListItem> =
      (organizationId
        ? organizationAppsQuery.data?.items
        : appsQuery.data?.items
      )?.map((app) => ({
        value: app._id,
        label: app.name,
        leading: <AppIcon app={app} />,
      })) ?? [];

    return appsQuery.isError ? (
      <ErrorMessage error={appsQuery.error} />
    ) : loaded ? (
      <Suggest {...other} items={items} ref={forwardedRef} />
    ) : (
      <Skeleton>
        <Field />
      </Skeleton>
    );
  },
);
